import { useEffect, useState } from 'react'

const TESTIMONIALS = [
  { initial: 'R', name: 'Rajesh Kumar', meta: 'Mumbai, India · Career Guidance', text: 'Maharaj Ji’s guidance completely changed my career. The remedies he suggested were simple, and within 3 months I got the promotion I had waited years for.' },
  { initial: 'S', name: 'Sarah Jenkins', meta: 'London, UK · Home & Vastu', text: 'I was unsure about an online consultation, but my Kundli reading was so accurate. His Vastu advice brought real peace and harmony to our home.' },
  { initial: 'A', name: 'Amit Patel', meta: 'New Jersey, USA · Business', text: 'His honest reading helped me take the right decision during a very tough business phase. Genuine Vedic wisdom with truly practical advice.' },
  { initial: 'M', name: 'Meera Nair', meta: 'Dubai, UAE · Money & Wealth', text: 'Calm, kind and very accurate. Maharaj Ji explained everything in simple words and the financial guidance helped my savings grow steadily.' },
]

export default function TestimonialsSection() {
  const [index, setIndex] = useState(0)
  const nav = (dir) => setIndex((i) => (i + dir + TESTIMONIALS.length) % TESTIMONIALS.length)

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % TESTIMONIALS.length), 8000)
    return () => clearInterval(t)
  }, [])

  return (
    <section className="relative overflow-hidden py-16 md:py-24 bg-[#120A05] text-white font-normal uppercase select-none">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-linear-to-b from-[#1A0E06] via-[#160B05] to-[#0C0703]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(60%_65%_at_50%_50%,rgba(232,119,15,0.1)_0%,transparent_75%)]"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="mb-10 flex flex-col items-center text-center md:mb-12">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-secondary/50"></span>
            <span className="text-[10px] tracking-[0.4em] text-secondary">Seeker Experiences</span>
            <span className="h-px w-8 bg-secondary/50"></span>
          </div>
          <h2 className="mt-3 font-heading text-3xl leading-tight text-[#FBF3E4] md:text-4xl">Authenticated <span className="text-gradient-gold font-bold">Testimonials</span></h2>
          <p className="mt-3 max-w-xl text-xs text-white/50 normal-case md:text-sm">Real outcomes from seekers who have transformed their lives through Vedic wisdom.</p>
        </div>

        <div className="relative max-w-5xl mx-auto overflow-hidden px-4">
          <div className="flex transition-transform duration-500 ease-in-out w-full" style={{ transform: `translateX(-${index * 100}%)` }}>
            {TESTIMONIALS.map((t) => (
              <div key={t.name} className="w-full shrink-0 px-2 md:px-4">
                <div className="group relative flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-white/4 p-8 backdrop-blur-sm transition-all duration-400 min-h-55">
                  <i className="fa-solid fa-quote-right pointer-events-none absolute right-6 top-6 text-4xl text-white/4"></i>
                  <div className="flex items-center gap-1 text-secondary">
                    {Array.from({ length: 5 }).map((_, i) => <i key={i} className="fa-solid fa-star text-xs"></i>)}
                  </div>
                  <p className="relative z-10 mt-4 flex-1 text-sm md:text-base italic leading-relaxed text-white/70 normal-case">“{t.text}”</p>
                  <div className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4">
                    <div className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-secondary/15 text-secondary ring-1 ring-secondary/25 font-bold">{t.initial}</div>
                    <div className="min-w-0 flex-1 text-left">
                      <h4 className="truncate font-heading text-sm text-[#FBF3E4] font-semibold">{t.name}</h4>
                      <p className="truncate text-[9px] tracking-[0.18em] text-white/40">{t.meta}</p>
                    </div>
                    <i className="fa-solid fa-circle-check text-secondary text-sm"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button onClick={() => nav(-1)} aria-label="Previous" className="absolute left-0 top-1/2 -translate-y-1/2 z-20 grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white shadow-lg backdrop-blur-md transition-all hover:bg-secondary hover:text-primary active:scale-90 border border-white/10"><i className="fa-solid fa-chevron-left"></i></button>
          <button onClick={() => nav(1)} aria-label="Next" className="absolute right-0 top-1/2 -translate-y-1/2 z-20 grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white shadow-lg backdrop-blur-md transition-all hover:bg-secondary hover:text-primary active:scale-90 border border-white/10"><i className="fa-solid fa-chevron-right"></i></button>
        </div>

        <div className="flex justify-center items-center gap-2 mt-8">
          {TESTIMONIALS.map((_, i) => (
            <button key={i} onClick={() => setIndex(i)} className={`h-1.5 rounded-full transition-all duration-300 ${i === index ? 'w-6 bg-secondary' : 'w-1.5 bg-white/20 hover:bg-white/40'}`}></button>
          ))}
        </div>
      </div>
    </section>
  )
}
